var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"button",attrs:{"type":"button","value":"✕"},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }